import HttpMethodType from "HttpMethodType";
import SubSystemType from "SubSystemType";
import BaseServiceRequest from "BaseServiceRequest";

export default class SaveUserEventFavouriteRequest extends BaseServiceRequest {
  constructor(data) {
    super();
    super.addRequestUri("futureeventsfavourite.pb");
    super.addRequestParameter("osid", data.osid);
    super.addRequestParameter("isStarred", data.is_starred);
    super.addRequestParameter("eventType", data.event_type);
    super.addRequestParameter("eventName", data.event_name);
    super.addRequestParameter("eventDate", data.event_date);
  }

  getMethod() {
    return HttpMethodType.POST;
  }

  getSubSystem() {
    return SubSystemType.LIST;
  }

  getMessageName() {
    return "SaveUserEventFavouriteRequest";
  }
}
